import { render } from "./DeployVMFromBackup.vue?vue&type=template&id=95871c0a&scoped=true"
import script from "./DeployVMFromBackup.vue?vue&type=script&lang=js"
export * from "./DeployVMFromBackup.vue?vue&type=script&lang=js"

import "./DeployVMFromBackup.vue?vue&type=style&index=0&id=95871c0a&lang=less&scoped=true"
import "./DeployVMFromBackup.vue?vue&type=style&index=1&id=95871c0a&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95871c0a"]])

export default __exports__